<error-unauthorized [title]="errorCms?.data?.attributes?.title" [description]="errorCms?.data?.attributes?.description">
  <ng-container extraContentLower>
    <div [innerHTML]="errorCms?.data?.attributes?.errorHelp?.data?.attributes?.copy | dontSanitizeHtml"></div>
  </ng-container>
</error-unauthorized>
